import { Link } from "react-router-dom";
import { Table2, UploadCloud } from "lucide-react";
import { Button } from "@/components/ui/button";

export default function EmptyTablePage() {
  return (
    <main data-testid="empty-table-page" className="mx-auto max-w-3xl px-4 py-16 sm:px-8">
      <div className="rounded-2xl border border-dashed border-slate-300 bg-white p-10 fade-up">
        <span className="flex h-12 w-12 items-center justify-center rounded-xl bg-slate-900 text-white"><Table2 className="h-6 w-6" /></span>
        <h1 className="mt-6 font-display text-2xl font-bold text-slate-900">Nessuna tabella movimenti</h1>
        <p className="mt-2 text-sm text-slate-500">Carica uno o più estratti conto PDF: al termine della conversione i movimenti compariranno qui.</p>
        <Button asChild data-testid="empty-table-upload-button" className="mt-6 rounded-full bg-emerald-700 text-white hover:bg-emerald-800 btn-lift">
          <Link to="/"><UploadCloud className="mr-2 h-4 w-4" /> Vai al caricamento file</Link>
        </Button>
      </div>
    </main>
  );
}
